import { useCallback } from 'react';
import { useBookingsQuery } from './bookings-query-context';
import { BookingView } from 'stores/rematch/models/types/bookings-store';
import { useDispatch } from 'react-redux';
import { IRootDispatch } from 'stores/rematch/root-store';
import { useBookingTabs } from './booking-tab-view-context';

export function useChangeView() {
  const dispatch = useDispatch<IRootDispatch>();
  const fetchBookings = useBookingsQuery((selector) => selector.fetchBookings);
  const setBookingListingActiveTab = dispatch.bookingsStore.setBookingListingActiveTab;
  const setBookingsFilter = dispatch.bookingsStore.setBookingsFilterV2;
  const setSelectedFilterKey = dispatch.bookingsStore.setSelectedFilterKey;
  const setDisplayedBookingListingTabs = dispatch.bookingsStore.setDisplayedBookingListingTabs;
  const updateViewSnapshot = useBookingTabs((selector) => selector.updateViewSnapshot);

  return useCallback(
    async (
      view: BookingView | undefined,
      views: BookingView[],
      opts?: {
        reset?: boolean;
        caller?: string;
        refreshDisplayedViews?: boolean;
        takeSnapshot?: boolean;
      },
    ) => {
      const { reset, caller, refreshDisplayedViews, takeSnapshot } = opts ?? { reset: false };

      if (view) {
        if (refreshDisplayedViews) {
          setDisplayedBookingListingTabs(views);
        }
        await fetchBookings({
          caller: caller ?? 'useChangeView',
          reset,
          viewId: view.customViewId,
          displayedBookingListingTabs: views,
          filters: view.filterValue,
        });
        setBookingListingActiveTab(view);
        setSelectedFilterKey(view.customViewId);
        setBookingsFilter(view.filterValue);
        if (takeSnapshot) {
          updateViewSnapshot(view);
        }
      }
    },
    [
      updateViewSnapshot,
      fetchBookings,
      setBookingsFilter,
      setSelectedFilterKey,
      setBookingListingActiveTab,
      setDisplayedBookingListingTabs,
    ],
  );
}
